import { GetContainersByVesselParams } from '../../../global/adapters/crpAPI';

export const searchContainersKeys = {
  root: ['search-containers'] as const,
  getContainersByVessel: (params: GetContainersByVesselParams) =>
    [...searchContainersKeys.root, 'get-containers-by-vessel', params] as const,
};
